import {Injectable} from '@angular/core';
import {HttpService} from '../http/http.service';
import {NoteModel} from '../../models/patient-file/patient-file.model';
import {catchError, map, Observable} from 'rxjs';
import {iResponse} from '../../models/response/response.model';

@Injectable({
    providedIn: 'root'
})
export class NoteService extends HttpService {

    postNote(patientId: string, patientFileId: string, note: NoteModel): Observable<iResponse<any>> {
        return this.post(`patients/${patientId}/patient-files/${patientFileId}/notes`, note).pipe(
            map((response: iResponse<any>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    putNote(patientId: string, patientFileId: string, note: NoteModel): Observable<iResponse<any>> {
        return this.put(`patients/${patientId}/patient-files/${patientFileId}/notes/${note.id}`, note).pipe(
            map((response: iResponse<any>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    deleteNote(patientId: string, patientFileId: string, noteId: string): Observable<iResponse<any>> {
        return this.delete(`patients/${patientId}/patient-files/${patientFileId}/notes/${noteId}`).pipe(
            map((response: iResponse<any>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
